import { render } from "./SchemaNavigation.vue?vue&type=template&id=737bb1e3"
import script from "./SchemaNavigation.vue?vue&type=script&lang=js"
export * from "./SchemaNavigation.vue?vue&type=script&lang=js"
script.render = render

export default script